
import { format } from 'date-fns'

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      testimonialSwiperOptions: {
        slidesPerView: 1,
        speed: 500,
        loop: true,
        pagination: {
          el: '.testi-swiper-pagination',
          clickable: true,
        },

        navigation: {
          nextEl: '.testi-swiper-btn-next',
        },
      },
    }
  },

  methods: {
    formatDate(date) {
      return format(new Date(date), 'dd.MM.yyyy')
    },
  },
}
